<template>
  <ViewCustomRow @addNewRow="addNewRow" @hide="onHideDialog" v-model:showRowDialog="showDialog" :rowId="rowId"
    :masterDetail="masterDetail" :dialogOptions="dialogOptions" :permissions="permissions" :entityKey="entityKey"
    entityName="news" entitySpec="row" ref="NewsDialog" :style="{ width: '70%' }" scheme="news"
    :dictionary="DICTIONARY_DIALOG" :requiredFields="{ news_title: true, news_severity_id: true, date_begin: true }">
    <template #header="{ rowData }">
      {{
        rowId === -1
          ? "Новое уведомление"
          : rowData.news_title
      }}
    </template>

    <template #body="{ rowData, reference, submitted }">
      <div class="formgrid grid align-items-center vertical-container">
        <div class="col-12">
          <div class="formgrid grid align-items-center vertical-container">
            <div class="col-1">
              <label for="news_severity_id" class="mb-1">Важность: </label>
            </div>
            <div class="col-2">
              <Dropdown id="news_severity_id" v-model="rowData.news_severity_id" :options="dialogOptions.news_severity"
                optionLabel="news_severity_name" optionValue="news_severity_id" appendTo="body"
                :class="getRequiredClass(submitted, rowData, 'news_severity_id')" />
            </div>
            <div class="col-1">
              <label for="news_title">Заголовок:</label>
            </div>
            <div class="col-6">
              <InputText id="news_title" autofocus v-model="rowData.news_title"
                :class="getRequiredClass(submitted, rowData, 'news_title')" />
            </div>
            <div class="col-1-5">
              <label for="row_is_ready">Готовность:</label>
            </div>
            <div class="col-0-5">
              <Checkbox id="row_is_ready" v-model="rowData.row_is_ready" binary />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-1">
              <label for="role_ids" class="mb-1">Роли: </label>
            </div>
            <div class="col-2">
              <MultiSelect v-model="rowData.role_ids" id="role_ids" :options="reference.roles" optionLabel="role_name"
                optionValue="role_id" placeholder="Роли" appendTo="body" />
            </div>
            <div class="col-1">
              <label for="server_prod_ids">Сервера:</label>
            </div>
            <div class="col-3">
              <MultiSelect v-model="rowData.server_prod_ids" id="server_prod_ids" :options="reference.servers"
                optionLabel="server_prod_id" optionValue="server_prod_id" placeholder="Сервера" appendTo="body">
                <template #option="slotProps">
                  <div>{{ slotProps.option.server_prod_id }}: {{ slotProps.option.dept_name }}</div>
                </template>
              </MultiSelect>
            </div>
            <div class="col-1">
              <label for="news_dept_ids">Подразделения:</label>
            </div>
            <div class="col-3">
              <MultiSelect v-model="rowData.news_dept_ids" id="news_dept_ids" :options="reference.depts"
                optionLabel="dept_name" optionValue="dept_id" placeholder="Подразделения" appendTo="body" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-1">
              <label for="date_begin" class="mb-1">Дата начала: </label>
            </div>
            <div class="col-2">
              <Calendar v-model="rowData.date_begin" dateFormat="dd.mm.yy" showIcon showButtonBar hideOnDateTimeSelect
                selectOtherMonths appendTo="body" :class="getRequiredClass(submitted, rowData, 'date_begin')" />
            </div>
            <div class="col-1">
              <label for="date_end">Дата оконч.:</label>
            </div>
            <div class="col-2">
              <Calendar v-model="rowData.date_end" dateFormat="dd.mm.yy" showIcon showButtonBar hideOnDateTimeSelect
                selectOtherMonths appendTo="body" />
            </div>
          </div>

          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-1">
              <label for="news_desc" class="mb-1">Описание: </label>
            </div>
            <div class="col-5">
              <Textarea v-model="rowData.news_desc" rows="8" class="fixed-textarea" />
            </div>
            <div class="col-1">
              <label for="date_end">Отображение:</label>
            </div>
            <div class="col-5">
              <div v-html="rowData.news_desc" />
            </div>
          </div>
        </div>
      </div>

      <TabView class="mt-1">
        <TabPanel header="Аудит">
          <ViewCustomData entityName="news_user" entitySpec="data" serviceName="BaseService" :columns="COLUMNS_AUDIT"
            scheme="news" :masterDetail="{ news_id: rowId }" ref="viewFacilityDevice" :paginator="false"
            scrollHeight="250px" />
        </TabPanel>
      </TabView>
    </template>
  </ViewCustomRow>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { ViewCustomRow } from 'cdisoft-library';
import { DICTIONARY_DIALOG, COLUMNS_AUDIT } from './newsConstants';

export default defineComponent({
  name: 'NewsDialog',
  mixins: [ViewCustomRow],  //не можем использовать <script setup> из за миксина
  setup() {
    const store = useStore();

    const prepareInsert = (rowData) => ({
      news_severity_id: rowData.news_severity_id,
      news_dept_ids: rowData.news_dept_ids ? rowData.news_dept_ids.join(',') : null,
      server_prod_ids: rowData.server_prod_ids ? rowData.server_prod_ids.join(',') : null,
      role_ids: rowData.role_ids ? rowData.role_ids.join(',') : null,
      news_title: rowData.news_title,
      news_desc: rowData.news_desc || null,
      date_begin: store.getters.formatSqlDateTime(rowData.date_begin),
      date_end: rowData.date_end ? store.getters.formatSqlDateTime(rowData.date_end) : null,
      row_is_ready: rowData.row_is_ready,
    });

    const prepareUpdate = (rowData) => {
      const data = prepareInsert(rowData);
      data.news_id = rowData.news_id;
      return data;
    };

    const prepareData = (rowData) => {
      rowData.role_ids = rowData.role_ids ? rowData.role_ids.split(',').map(Number) : null;
      rowData.server_prod_ids = rowData.server_prod_ids ? rowData.server_prod_ids.split(',').map(Number) : null;
      rowData.news_dept_ids = rowData.news_dept_ids ? rowData.news_dept_ids.split(',').map(Number) : null;
      rowData.date_begin = rowData.date_begin ? new Date(rowData.date_begin) : null;
      rowData.date_end = rowData.date_end ? new Date(rowData.date_end) : null;
      return rowData;
    };

    const beforeOpenNewRow = (rowData) => {
      rowData.row_is_ready = false;
    };

    const getRequiredClass = (submitted, rowData, field) => ({
      'p-invalid': submitted ? (rowData[field] || '') === '' : false,
    });

    return {
      DICTIONARY_DIALOG,
      COLUMNS_AUDIT,
      prepareInsert,
      prepareUpdate,
      prepareData,
      beforeOpenNewRow,
      getRequiredClass,
    };
  },
});
</script>
